// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagFilledSvg from "@fishx/icons-svg/es/asn/TagFilled";
import FishxIcon from '../components/FishxIcon';

var TagFilled = function TagFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagFilledSvg
  }));
};

TagFilled.displayName = 'TagFilled';
export default React.forwardRef(TagFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagFilled.js
// module id = 4229
// module chunks = 0